module.exports = __webpack_public_path__ + "static/media/95be4d50.jpg";